import ActiveCallWrapper from "./ActiveCallWrapper";

export default ActiveCallWrapper;
